import React from 'react';

type Props = {
  width: number;
  height: number;
};

const SvgIconPencil = (props: Props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      version="1.0"
      viewBox="0 0 16 16"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
    >
      <g
        id="Master"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Manage-TB---Feature-Flags"
          transform="translate(-1352.000000, -253.000000)"
          fill="#318AFB"
        >
          <g
            id="Table"
            transform="translate(280.000000, 164.000000)"
          >
            <g
              id="Row-1"
              transform="translate(32.000000, 82.000000)"
            >
              <path
                d="M1046.15308,20.0901953 C1046.14564,20.0901953 1046.14564,20.0976372 1046.1382,20.1050791 C1046.13075,20.1050791 1046.13075,20.1125209 1046.12331,20.1125209 C1046.11587,20.1125209 1046.11587,20.1199628 1046.10843,20.1199628 C1046.10099,20.1199628 1046.10099,20.1274047 1046.09354,20.1274047 C1045.91494,20.2315907 1045.40145,20.5069395 1044.13633,20.960893 C1043.9875,21.012986 1043.83122,21.0725209 1043.66006,21.1320558 L1041.87401,19.3385674 C1041.93354,19.1674047 1041.98564,19.0111256 1042.04517,18.8622884 C1042.49913,17.5971721 1042.77447,17.0762419 1042.87866,16.8976372 C1042.87866,16.8901953 1042.8861,16.8901953 1042.8861,16.8827535 C1042.89354,16.8753116 1042.89354,16.8678698 1042.89354,16.8678698 C1042.89354,16.8604279 1042.90099,16.8604279 1042.90099,16.852986 C1042.90843,16.8455442 1042.90843,16.8381023 1042.91587,16.8381023 L1043.04982,16.7041488 L1046.29447,19.9488 L1046.15308,20.0901953 Z M1052.65727,7.31252093 C1052.24052,6.89577674 1051.55587,6.89577674 1051.13905,7.31252093 L1050.75959,7.69205581 L1042.39494,16.056707 L1042.23122,16.2278698 C1042.23122,16.2278698 1041.6954,16.7636837 1040.48982,20.6557767 C1040.48238,20.6855442 1040.47494,20.7078698 1040.4675,20.7376372 C1040.44517,20.804614 1040.42285,20.8790326 1040.40052,20.9534512 C1040.3782,21.0204279 1040.36331,21.0799628 1040.34099,21.1469395 C1040.3261,21.1990326 1040.31122,21.2585674 1040.28889,21.3106605 C1040.25168,21.4371721 1040.21447,21.5711256 1040.16982,21.7050791 C1040.08052,21.9953116 1039.87215,22.6650791 1040.11029,22.9032186 C1040.34099,23.1339163 1041.01075,22.932986 1041.30099,22.8436837 C1041.43494,22.8064744 1041.56145,22.7692651 1041.68796,22.724614 C1041.7475,22.7097302 1041.79959,22.6874047 1041.85913,22.6725209 C1041.91866,22.6501953 1041.9782,22.6353116 1042.03773,22.612986 C1042.11215,22.5906605 1042.18657,22.5683349 1042.26099,22.5460093 C1042.28331,22.5385674 1042.30564,22.5311256 1042.32796,22.5236837 C1046.03401,21.3701953 1046.69633,20.8269395 1046.74843,20.7822884 L1046.75587,20.7822884 L1046.92703,20.6111256 L1046.94192,20.6260093 L1055.30649,12.2539163 L1055.6861,11.8743814 C1056.10285,11.4576372 1056.10285,10.772986 1055.6861,10.3562419 L1052.65727,7.31252093 Z"
                id="Edit"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SvgIconPencil;
